import { Analytics } from '@cobliteam/analytics';
import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';
import { motion } from 'motion/react';
import { useState } from 'react';
import AIAssistantWelcome from '../../components/AIAssistantWelcome';
import { useAIAssistant } from '../../store';
import AIAssistantChat from './AIAssistantChat';

const HEIGHT = '700px';
const MAX_HEIGHT = '700px';
const MAX_HEIGHT_CLASS = 'max-h-[700px]';
const WIDTH = '400px';
const WIDTH_CLASS = 'w-[400px]';
const EXPANDED_MAX_WIDTH = 'calc(100vw - var(--sidebar-width))';

type AssistantPanelVariant = 'popover' | 'sidepanel';

interface AIAssistantPanelContentProps {
  variant?: AssistantPanelVariant;
  onClose?: () => void;
}

const AIAssistantPanelContent = ({ variant = 'popover', onClose }: AIAssistantPanelContentProps) => {
  const { threadId, newThreadId } = useAIAssistant();
  const [isExpanded, setIsExpanded] = useState(false);
  const isSidepanel = variant === 'sidepanel';
  const activeConversationKey = threadId || newThreadId;
  const closeButton = onClose ? (
    <Button
      variant='ghost'
      size='sm'
      icon={<Icon name='x' />}
      className='h-8 w-8 p-0'
      onClick={() => {
        Analytics.track('AI - Sidepanel - Closed');
        onClose();
      }}
      data-testid='ai-header-close'
    />
  ) : null;

  const content = (
    <AIAssistantChat
      key={activeConversationKey}
      showHeader
      isExpanded={isExpanded}
      onExpand={isSidepanel ? undefined : () => setIsExpanded((current) => !current)}
      headerActions={closeButton}
    >
      <AIAssistantWelcome />
    </AIAssistantChat>
  );

  if (isSidepanel) {
    return <div className='flex h-full flex-1 flex-col overflow-hidden'>{content}</div>;
  }

  return (
    <motion.div
      animate={{
        height: isExpanded ? MAX_HEIGHT : HEIGHT,
        width: isExpanded ? EXPANDED_MAX_WIDTH : WIDTH,
      }}
      className='overflow-hidden'
    >
      <div className={cn(MAX_HEIGHT_CLASS, !isExpanded && WIDTH_CLASS)}>{content}</div>
    </motion.div>
  );
};

export default AIAssistantPanelContent;
